export default __webpack_public_path__ + "static/sunsoaked-banner-mobile-266e715bf3a9c987345ebfc2b71c2529.webp";